<template>
    <div
        id="past-projects-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <base-text type="h3" class="heading">{{ data.heading }}</base-text>
        <projects-preview
            heading="2019 Projects"
            :projects="projects('2019')"
        />
        <projects-preview
            heading="2018 Projects"
            :projects="projects('2018')"
        />
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/past-projects.md';

    import ProjectsPreview from '../components/ProjectsPreview';

    export default {
        name: 'past-projects',

        mixins: [dataLoader(data)],

        components: {
            ProjectsPreview,
        },

        methods: {
            projects(year) {
                return this.data.projects.filter(
                    project => project.year === year
                );
            },
        },
    };
</script>

<style lang="scss" scoped>
    #past-projects-page {
        margin: 150px 0;

        &.tablet,
        &.mobile {
            margin: 100px 0;
        }

        .heading {
            margin-bottom: $standard-space;
        }

        &.mobile {
            .heading {
                margin-bottom: $standard-space-mobile;
            }
        }
    }
</style>
